import InlineLoader from "../../../components/ui/inline-loader/InlineLoader";
import {IProfilePasswordModalAction} from "../types";

export interface IAddUserModalButtons {
  isLoading: boolean,
  isDisabled: boolean,
  isUpdate?: boolean,
  requestClick: (event: IProfilePasswordModalAction) => void
}

export default function AddUserModalButtons({isLoading, requestClick, isDisabled, isUpdate}: IAddUserModalButtons) {
  return (
    <div className="change-pass-modal-footer modal__footer d-flex">
      {
        isLoading && <InlineLoader />
      }

      <button type="button"
              disabled={isLoading}
              className={`${isLoading ? 'change-pass-modal-footer__action--disabled' : ''} change-pass-modal-footer__action modal__footer__action btn btn--mute`}
              onClick={() => {
                if (isLoading) {
                  return;
                }

                return requestClick(IProfilePasswordModalAction.CANCEL);
              }}>
        Cancel
      </button>

      <button type="button"
              disabled={isDisabled || isLoading}
              className={`${isDisabled || isLoading ? 'change-pass-modal-footer__action--disabled' : ''} change-pass-modal-footer__action modal__footer__action btn btn--default`}
              onClick={() => {
                if (isDisabled || isLoading) {
                  return;
                }

                return requestClick(IProfilePasswordModalAction.SAVE);
              }}>
        Continue
      </button>
    </div>
  )
}
